import { useMediaQuery, useTheme } from '@mui/material';
import clsx from 'clsx';
import { useSnackbar } from 'notistack';
import React, { useEffect, useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { connect, ConnectedProps } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBackIosNew';

import Preloader from '../../../components/ui/Preloader/Preloader';

import { actions as cartActions } from '../../../store/ducks/cart.duck';
import { actions as categoriesActions } from '../../../store/ducks/categories.duck';
import { actions as productCatalogActions } from '../../../store/ducks/product-catalog.duck';
import { actions as productTypesActions } from '../../../store/ducks/productType.duck';
import { actions as profileActions } from '../../../store/ducks/profile.duck';
import { IAppState } from '../../../store/rootDuck';
import { setLayoutFooter, setLayoutSubheader } from '../../../utils/layout';
import { useStylesProductCatalog } from './hooks/useStyles';
import { useGetRootsCategories } from './hooks/useGetRootsCategories';
import CatalogCategory from './components/CatalogCategory';
import { ICategoryItem } from '../categories/interfaces';
import { useGetChildrenCategories } from './hooks/useGetChildrenCategories';
import { updateCategoryChildren } from './utils/updateCategoryChildren';
import { useFetchCatalogCategories } from '../../../hooks/useFetchCatalogCategories';
import { useGetFavoritesCategories } from '../../../../_base/layout/footer/useGetFavoritesCategories';
import { NewProductsByCategory } from './components/NewProductsByCategory';

const ProductNewCatalog: React.FC<TPropsFromRedux> = ({
  search,
  sortType,
  // loading,
  page,
  perPage,
  deleteError,
  // loadingMe,
  // catalogCategories,
  me,
  clearProducts,
  clearDel,
  fetchMe,
  clearMe,
  // fetchCatalogCategories,
  setViewType,
  setSearch,
  isSearching,
  fetchTypeById,
  clearParams,
  fetchType,
  clearAddProduct,
  // loadingTypes,
  // categoriesLoading,
  // catalogLoading,
  categoryIdActive,
  setCategoryIdActive,
  clearRequest,
  setSearchText,
}) => {
  const { classes } = useStylesProductCatalog();

  const intl = useIntl();
  const location = useLocation() as any;
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const [columns, setColumns] = useState(1);
  const navigate = useNavigate();
  const [categoryList, setCategoryList] = useState<any[][]>([[], [], []]);
  const [catalogCategories, setCatalogCategories] = useState<ICategoryItem[]>([]);
  const { fetch: fetchRoot, categories: categoriesRoot } = useGetRootsCategories();
  const { getCategories: fetchFavoritesCategories, categories: categoriesFavorites, loading: loadingFavorites } =
    useGetFavoritesCategories();
  const isTabletScreen = useMediaQuery(theme.breakpoints.down(950));
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(560));
  const { fetchCatalogCategories } = useFetchCatalogCategories();

  const updateCatalog = (newCategories: ICategoryItem[], id: number) => {
    const newCategoryList = updateCategoryChildren(catalogCategories, id, newCategories);
    setCatalogCategories(newCategoryList);
  };

  const {
    fetch: fetchChildren,
    categories: categoryChildren,
    loading: loadingChildren,
    success: successChildren,
  } = useGetChildrenCategories(updateCatalog);

  const isRootCategories = useMemo(() => {
    if (
      categoryList?.[0]?.[0]?.id === catalogCategories?.[0]?.id &&
      categoryList?.[1]?.[0]?.id === catalogCategories?.[1]?.id &&
      categoryList?.[2]?.[0]?.id === catalogCategories?.[2]?.id
    )
      return true;
    return false;
  }, [catalogCategories, categoryList]);

  useEffect(() => {
    if (isMobileScreen) setColumns(1);
    else if (isTabletScreen) setColumns(2);
    else setColumns(3);
  }, [isTabletScreen, isMobileScreen]);

  useEffect(() => {
    if (successChildren && categoryChildren) {
      setCategoryList(getResult(categoryChildren));
    }
  }, [successChildren]);

  useEffect(() => {
    if (categoriesRoot) {
      setCatalogCategories(categoriesRoot);
    }
  }, [categoriesRoot]);

  useEffect(() => {
    setCategoryIdActive(0);
    fetchMe();
    clearParams();
    fetchType();
    setViewType('grid');
    fetchFavoritesCategories();
    return () => {
      clearMe();
      clearProducts();
      clearDel();
      clearAddProduct();
      clearParams();
    };
  }, []);

  useEffect(() => {
    fetchRoot({
      per_page: 300,
      with_products: me?.is_admin ? undefined : 1,
      only_active: me?.is_admin ? undefined : 1,
    });
    fetchCatalogCategories({
      with_products: me?.is_admin ? undefined : true,
      only_active: me?.is_admin ? undefined : 1,
    });
  }, [me]);

  const getResult = (categories: any) => {
    let result: any[][] = [[], [], []];
    categories?.forEach((item: any, index: number) => {
      return result[index % 3].push(item);
    });
    return result;
  };

  useEffect(() => {
    const isAllEmpty = categoryList?.every(i => !i || i.length === 0);
    if (isAllEmpty) {
      const result = getResult(catalogCategories);
      setCategoryList(result || [[], [], []]);
    }
  }, [catalogCategories]);

  useEffect(() => {
    if (location?.state?.categoryId) {
      setSearch(true);
      setCategoryIdActive(location.state.categoryId);
    }
    if (location?.state?.productTypeId) {
      fetchTypeById({ id: location.state.productTypeId, filters: true });
    }
  }, [location]);

  useEffect(() => {
    if (search) setSearch(true);
  }, [sortType, search, page, perPage]);

  useEffect(() => {
    if (deleteError) {
      enqueueSnackbar(deleteError, { variant: 'error' });
      clearDel();
    }
  }, [deleteError]);

  const handleBackPress = () => {
    setCategoryList(getResult(catalogCategories));
    setCategoryIdActive(0);
  };

  setLayoutFooter({ show: true });

  const findPathById = (arr: any[], targetId: number | undefined | null, path = []): any => {
    if (!arr.length || !targetId) {
      return ['Нет даты'];
    }

    for (const item of arr) {
      const newPath: any = [...path, { name: item.name, id: item.id }];

      if (item.id === targetId) {
        return newPath;
      }

      if (item.children && item.children.length > 0) {
        const foundPath = findPathById(item.children, targetId, newPath);
        if (foundPath) {
          return foundPath;
        }
      }
    }

    return null;
  };

  // setLayoutSubheader(
  //   categoryIdActive
  //     ? {
  //         breadcrumb: [
  //           {
  //             name: intl.formatMessage({ id: 'PRODUCT.CATALOG.ALL.CATEGORIES' }),
  //           },
  //           ...(findPathById(catalogCategories || [], categoryIdActive) || []),
  //         ].map((element: any) => {
  //           return {
  //             title:
  //               element.name?.length > 30 ? `${element.name.slice(0, 30)} ... ` : element.name,
  //             hoverTitle: element.name,
  //             root: true,
  //             id: element.id,
  //             children: element.children,
  //             page:
  //               element.name === intl.formatMessage({ id: 'PRODUCT.CATALOG.ALL.CATEGORIES' })
  //                 ? 'products/catalog/categories'
  //                 : 'products/catalog',
  //             onClickCategory: (id: number) => {
  //               setSearchText('');
  //               setCategoryIdActive(id);
  //             },
  //             click: () => {
  //               if (
  //                 element.name === intl.formatMessage({ id: 'PRODUCT.CATALOG.ALL.CATEGORIES' })
  //               ) {
  //                 setCategoryList(getResult(catalogCategories));
  //                 setCategoryIdActive(0);
  //               } else {
  //                 setCategoryIdActive(element.id || 0);
  //               }
  //             },
  //             isActive: element.id === categoryIdActive,
  //           };
  //         }),
  //       }
  //     : {
  //         breadcrumb: [
  //           {
  //             title: intl.formatMessage({ id: 'PRODUCT.CATALOG.ALL.CATEGORIES' }),
  //             page: 'products/catalog/categories',
  //             root: true,
  //             translate: 'PRODUCT.CATALOG.ALL.CATEGORIES',
  //             isActive: true,
  //           },
  //         ],
  //       }
  // );

  const handlePressCategoryTitle = (category: ICategoryItem) => {
    if (!category?.id) return;
    setCategoryIdActive(category.id);
    setSearchText('');
    clearRequest();
    navigate('/products/catalog');
  };

  const onPressCategory = (category: ICategoryItem) => {
    category.id && setCategoryIdActive(category.id);
    if (!category.count_children_active) {
      clearRequest();
      setSearchText('');
      navigate('/products/catalog');
      return;
    }
    category.id &&
      fetchChildren({
        id: category.id,
        per_page: 300,
        with_products: me?.is_admin ? undefined : 1,
        only_active: me?.is_admin ? undefined : 1,
      });
    // setCategoryList(getResult(category.children));
    window.scrollTo(0, 0);
  };

  // if (categoriesLoading || catalogLoading || loadingMe || loadingTypes || loading) {
  //   return <Preloader />;
  // }

  return (
    <div className={classes.container}>
      <div className={classes.productsCol}>
        {categoriesFavorites.map(i => (
          <NewProductsByCategory category={i} handlePressCategoryTitle={handlePressCategoryTitle} />
        ))}
        {/* <div className={clsx(classes.card, { [classes.revers]: isSearching })}>
          {(!categoryList?.length) ? (
            <Preloader />
          ) : (
            <div>
              {!isRootCategories && !loadingChildren ? (
                <p className={classes.backTitle} onClick={handleBackPress}>
                  <ArrowBackIcon />
                  {intl.formatMessage({
                    id: 'AUTH.BUTTON.BACK',
                  })}
                </p>
              ) : null}
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: `repeat(${columns}, 1fr)`,
                  gap: '20px',
                }}
              >
                {categoryList.map(e => {
                  return (
                    <div>
                      {e
                        ?.filter((cat: any) => cat?.active)
                        .map((cat: any) => (
                          <CatalogCategory
                            key={cat.id}
                            cat={cat}
                            handlePressCategoryTitle={handlePressCategoryTitle}
                            onPressCategory={onPressCategory}
                            updateCatalog={updateCatalog}
                          />
                        ))}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div> */}
      </div>
    </div>
  );
};

const connector = connect(
  (state: IAppState) => ({
    loading: state.productsCatalog.loading,
    page: state.productsCatalog.page,
    perPage: state.productsCatalog.per_page,
    deleteError: state.productsCatalog.delError,
    isSearching: state.productsCatalog.isSearching,

    catalogCategories: state.categories.catalogCategories,
    categoriesLoading: state.categories.categoriesLoading,
    catalogLoading: state.categories.catalogLoading,

    me: state.profile.me,
    loadingMe: state.profile.loading,

    loadingTypes: state.productTypes.loading,
    sortType: state.productsCatalog.sortType,
    search: state.productsCatalog.search,
    categoryIdActive: state.productsCatalog.categoryIdActive,
  }),
  {
    clearProducts: productCatalogActions.clearProducts,
    clearDel: productCatalogActions.clearDel,
    clearRequest: productCatalogActions.clearRequest,
    setSearchText: productCatalogActions.setSearching,
    setViewType: productCatalogActions.setViewType,
    setSearch: productCatalogActions.setSearch,
    setCategoryIdActive: productCatalogActions.setCategoryIdActive,

    fetchMe: profileActions.fetchRequest,
    clearMe: profileActions.clearMe,

    fetchCatalogCategories: categoriesActions.fetchCatalogCategories,

    fetchTypeById: productTypesActions.fetchParamsByIdRequest,
    clearParams: productTypesActions.clearParams,
    fetchType: productTypesActions.fetchRequest,

    clearAddProduct: cartActions.clearAddProduct,
  }
);

type TPropsFromRedux = ConnectedProps<typeof connector>;

export default connector(ProductNewCatalog);
